/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Test_ConnectionInputs */



/**
* | output |
* | --- |
* | "Test Connection" |
*
* @param {Live_Caption_Test_ConnectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_test_connection = /** @type {((inputs?: Live_Caption_Test_ConnectionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Test_ConnectionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Test de connexion")
	if (locale === "de") return /** @type {LocalizedString} */ ("Testverbindung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Connessione di prova")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проверить соединение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Probar conexión")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("测试连接")
	if (locale === "ja") return /** @type {LocalizedString} */ ("接続テスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कनेक्शन का परीक्षण करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Conexão de teste")
	return /** @type {LocalizedString} */ ("Test Connection")
});